/**
 * Route guard for the internal admin console (v1-2-5).
 *
 * Client-side gate: if there is no staff token, redirect to /admin/login. This
 * is convenience only — every admin API call is independently staff-gated
 * server-side (fail-closed), so a forged client state can never reach data.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../lib/auth';

export function RequireStaff({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

export default RequireStaff;
